//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { FileList } from './FileList/FileList';
import { FileView } from './FileView/FileView';
import { TaskView } from './TaskView/TaskView';
import { RuleList } from './RuleList/RuleList';
import { RuleView } from './RuleView/RuleView';

//#endregion

//-----------------------------------------------------------------
export function DocAnalytics() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const path_rule_list = '/rules';
  const path_rule_view = '/rules/:rule_id';
  const path_file_list = '/files';
  const path_file_view = '/files/:file_id';
  const path_task_view = '/files/:file_id/exceptions/:exception_id';
  const path_doct_view = '/files/:file_id/task';
  const path_misc      = '/*';
  const path_main      = '/main';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: `calc(100% - 5rem)`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
  }

  //#endregion

  //#region [Main] render information
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <Routes>
          <Route path={ path_rule_list } element={ <RuleList />  } />
          <Route path={ path_rule_view } element={ <RuleView />  } />
          <Route path={ path_task_view } element={ <TaskView />  } />
          <Route path={ path_doct_view } element={ <TaskView />  } />
          <Route path={ path_file_view } element={ <FileView />  } />
          <Route path={ path_file_list } element={ <FileList />  } />
          <Route path={ path_misc      } element={ <Navigate to='files' replace /> } />
        </Routes>
      </Box>
    )
  }

  //-----------------------------------------------------------------
  function displayMain() {
    //-----------------------------------------------------------------
    return (
      <div style={{height: '100%', display: 'grid'}} >
        <FileList />
        <RuleList />
      </div>
    )
  }

  //#endregion

  return display();
}
